import BaseModel from '../base';

export default class Answer extends BaseModel {
  constructor(answer = {}, url) {
    super(answer, url);

    this.check_user_id = answer.check_user_id;
    this.documents = [].concat(answer?.documents || [], answer.response?.at?.(0)?.documents || []);
    this.event_poll_journal_id = answer.event_poll_journal_id;
    this.event_poll_questions_id = answer.event_poll_questions_id;
    this.images = [].concat(answer?.images || [], answer.response?.at?.(0)?.images || []);
    this.owner_id = answer.owner_id;
    this.response = answer.response || [];
    this.score = answer.score || 0;

    this.deletedFiles = {
      links: [],
      images: [],
      documents: [],
    };
  }

  get responseValue() {
    const [firstResponse] = this.response;

    return { ...firstResponse || {} };
  }

  set responseValue(val) {
    const [firstResponse] = this.response;
    const firstResponseIdx = this.response.findIndex((i) => i.id === firstResponse.id);

    if (firstResponseIdx === -1) {
      this.response.push(val);
      return;
    }

    this.response.splice(firstResponseIdx, 1, val);
  }

  get outputData() {
    const { response, images, documents } = this;

    return {
      response,
      ...documents.length ? { documents } : [],
      ...images.length ? { images } : [],
    };
  }
}
